import { fetch } from 'libs/fetch';

/**
 * 查询是否购买过新开项目权益
 * @param type
 * @returns
 */
export async function apiGetProjectNewAddHasEquity(options?: FetchOptions) {
  const res = await fetch(`/api/basic/v2/newProject/checkBenefit`, {
    method: 'GET',
    ...options,
  });
  return res;
}

/**
 * 通过权益code查商品
 * @param type
 * @returns
 */
export async function apiGetSkuByBenefitCode(query) {
  const res = await fetch(`/api/mall/v1/mallServiceSku/findSkuByBenefitCode`, {
    method: 'GET',
    query,
  });
  return res;
}

/**
 * 获取地区树
 * @param options
 */
export async function getAllAreaTree() {
  const res = await fetch('/api/ifs/v1/basis/area/getSelectCascadeArea', {
    method: 'GET',
  });
  return res;
}

/**
 * 项目上新获取组织树
 * @param options
 */
export async function getOrgTree() {
  const res = await fetch('/api/basic/v1/scm/project/getOrgTree', {
    method: 'GET',
  });
  return res;
}

/**
 * 项目上新获取权益次数
 * @param options
 */
export async function apiGetEquityNum(json) {
  const res = await fetch('/api/ifs/v1/supplier/benefit/check', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 核销次数
 * @param options
 */
export async function apiSubProjectEquityNum(query) {
  const res = await fetch('/api/basic/v2/newProject/useNewProjectBenefit', {
    method: 'GET',
    query,
  });
  return res;
}
